<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center justify-content-between mb-3 gap-3">
    <p class="m-0 text-600 text-sm">
      A global block is defined once and placed on as many pages as you like. Edit it here and every page that uses it
      changes when you publish it.
    </p>
    <button pButton pRipple type="button" label="New global block" icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0 white-space-nowrap" (click)="onAdd()" data-testid="global-block-new"></button>
  </div>

  <p-table [value]="blocks(account.data?.content)" styleClass="p-datatable-striped" dataKey="_meta.id"
    responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Blocks</th>
        <th>Used on</th>
        <th style="width: 12rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-block>
      <tr [attr.data-global-block]="block._meta.id">
        <td><strong>{{ block.name || '(unnamed)' }}</strong></td>
        <td>{{ blockCount(block) }}</td>
        <td [pTooltip]="usedOnTitle(account.data?.content, block)" tooltipPosition="top">
          {{ usedOn(account.data?.content, block).length }} place(s)
        </td>
        <td class="white-space-nowrap">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEdit(block)"
            class="p-button-rounded p-button-text" pTooltip="Edit" tooltipPosition="top"></button>
          <button pButton pRipple type="button"
            [icon]="publishingId === block._meta.id ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
            (click)="onPublish(account.data?.content, block)" [disabled]="!!publishingId"
            class="p-button-rounded p-button-text" pTooltip="Publish just this global block to the staging preview" tooltipPosition="top"></button>
          <button pButton pRipple type="button" icon="pi pi-trash" (click)="onDelete(account.data?.content, block)"
            [disabled]="usedOn(account.data?.content, block).length > 0"
            class="p-button-rounded p-button-danger p-button-text"
            [pTooltip]="usedOn(account.data?.content, block).length ? 'Still in use: remove it from those pages and templates (or detach it into a copy) first' : 'Remove'"
            tooltipPosition="top"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="p-text-center muted p-py-5">
          <span *ngIf="!loadFailed">
            No global blocks yet. Use "New global block", or "Save as global block" on any block of a page.
          </span>
          <span *ngIf="loadFailed" class="app-text-overdue">
            <i class="pi pi-exclamation-triangle mr-2"></i>
            The website content couldn't be loaded, so this list is empty because of an error, not because there are
            none. Close and reopen to try again.
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

</ng-container>

<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
